import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, vModelText as _vModelText, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "project-finance" }
const _hoisted_2 = { class: "finance-content-grid" }
const _hoisted_3 = { class: "balance-card-modern" }
const _hoisted_4 = { class: "balance-card-background" }
const _hoisted_5 = { class: "balance-card-content" }
const _hoisted_6 = { class: "balance-label" }
const _hoisted_7 = { class: "balance-actions" }
const _hoisted_8 = { class: "stats-grid" }
const _hoisted_9 = { class: "stat-card" }
const _hoisted_10 = { class: "stat-header" }
const _hoisted_11 = { class: "stat-label" }
const _hoisted_12 = { class: "stat-value" }
const _hoisted_13 = { class: "stat-change positive" }
const _hoisted_14 = { class: "stat-card" }
const _hoisted_15 = { class: "stat-header" }
const _hoisted_16 = { class: "stat-label" }
const _hoisted_17 = { class: "stat-value" }
const _hoisted_18 = { class: "stat-change negative" }
const _hoisted_19 = { class: "stat-card" }
const _hoisted_20 = { class: "stat-header" }
const _hoisted_21 = { class: "stat-label" }
const _hoisted_22 = { class: "stat-value" }
const _hoisted_23 = { class: "stat-change" }
const _hoisted_24 = { class: "stat-card" }
const _hoisted_25 = { class: "stat-header" }
const _hoisted_26 = { class: "stat-label" }
const _hoisted_27 = { class: "stat-value" }
const _hoisted_28 = { class: "stat-change" }
const _hoisted_29 = { class: "transactions-section" }
const _hoisted_30 = { class: "section-header" }
const _hoisted_31 = { class: "section-title" }
const _hoisted_32 = { class: "badge" }
const _hoisted_33 = { class: "tab-buttons" }
const _hoisted_34 = {
  key: 0,
  class: "pending-count"
}
const _hoisted_35 = {
  key: 0,
  class: "pending-count"
}
const _hoisted_36 = { class: "tab-content" }
const _hoisted_37 = { class: "tab-content" }
const _hoisted_38 = { class: "tab-content" }
const _hoisted_39 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_40 = { class: "reject-provisioning-modal" }
const _hoisted_41 = { class: "reject-provisioning-modal__header" }
const _hoisted_42 = { class: "reject-provisioning-modal__text" }
const _hoisted_43 = { class: "reject-provisioning-modal__message" }
const _hoisted_44 = { class: "reject-provisioning-modal__details" }
const _hoisted_45 = { class: "reject-provisioning-modal__details-text" }
const _hoisted_46 = { class: "reject-provisioning-modal__notes" }
const _hoisted_47 = {
  for: "rejectionNotes",
  class: "reject-provisioning-modal__label"
}
const _hoisted_48 = ["placeholder"]
const _hoisted_49 = { class: "reject-provisioning-modal__actions" }

import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from '@/composables/useStore';
import { usePermissions } from '@/composables/usePermissions';
import { useNotifications } from '@/composables/useNotifications';
import AppButton from '@/components/base/AppButton.vue';
import AppDataGrid from '@/components/base/AppDataGrid.vue';
import AppModal from '@/components/base/Modal.vue';
import financeService from '@/services/finance.service';
import DocumentService from '@/services/documents.service';
import DocumentViewerModal from '../documents/DocumentViewerModal.vue';
import RecordPaymentModal from './RecordPaymentModal.vue';
import RecordExpenseModal from './RecordExpenseModal.vue';
import ProvisioningRequestModal from './ProvisioningRequestModal.vue';
import ConfirmModal from '@/components/common/ConfirmModal.vue';
import PermissionGuard from '@/components/common/PermissionGuard.vue';
import projectTasksService from '@/services/projectTasks.service';
import intervenantsService from '@/services/intervenants.service';
import { provisioningRequestService } from '@/services/provisioningRequest.service';
import { formatCurrencyWithUserPreference } from '@/utils/currencyUtils';
import { PermissionType } from '@/services/permission.service';
import type { ProvisioningRequestData } from '@/types/services';

interface Props {
  projectId: string | number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectFinance',
  props: {
    projectId: {}
  },
  setup(__props: any) {

/// <reference types="vue" />
// @ts-ignore
const props = __props;

const { t } = useI18n();
const store = useStore();
const { hasPermissionForProject } = usePermissions();
const { notifySuccess, notifyError } = useNotifications();

// State
const activeTab = ref('history');
const projectBalance = ref(0);
const formattedBalance = ref('€0.00');
const transactions = ref([]);
const pendingPayments = ref([]);
const formattedPendingAmounts = ref({});
const formattedTransactionAmounts = ref({});
const showRecordPaymentModal = ref(false);
const showRecordExpenseModal = ref(false);
const showProvisioningModal = ref(false);

// Provisioning request to approve (pre-fill payment modal)
const provisioningRequestToApprove = ref(null);

// Provisioning requests state
const provisioningRequests = ref([]);
const formattedProvisioningAmounts = ref({});
const pendingProvisioningCount = ref(0);
const showProvisioningResponseModal = ref(false);
const provisioningRequestToRespond = ref(null);
const provisioningResponseType = ref<'approve' | 'reject'>('approve');

// Provisioning reject confirmation modal
const showRejectProvisioningModal = ref(false);
const provisioningRequestToReject = ref(null);
const rejectionNotes = ref('');

// Confirmation modal state
const showCancelPaymentModal = ref(false);
const paymentToCancel = ref(null);
// Document viewer state
const showDocumentViewerModal = ref(false);
const selectedDocument = ref(null);

// Tasks list state
const tasks = ref([]);
const loadingTasks = ref(false);

// Intervenants list state
const intervenants = ref([]);
const loadingIntervenants = ref(false);

// Add watchers to track modal visibility

watch(showRecordPaymentModal, (newVal: boolean) => {
  console.log('Payment modal visibility changed to:', newVal);
});

watch(showRecordExpenseModal, (newVal: boolean) => {
  console.log('Expense modal visibility changed to:', newVal);
});

// Grid state
const pendingPaymentsGridApi = ref(null);
const transactionsGridApi = ref(null);

//  Edit payment
const showEditPaymentModal = ref(false);
const editingPayment = ref(null);

//  Edit expense
const showEditExpenseModal = ref(false);
const editingExpense = ref(null);

// Cancel transaction
const showCancelTransactionModal = ref(false);
const transactionToCancel = ref(null);

// Grid configuration
const defaultColDef = {
  sortable: true,
  resizable: true
};

// Column definitions for pending payments grid - make reactive to language changes
const pendingPaymentsColumns = computed(() => [
  {
    field: 'transactionDate',
    headerName: t('finance.date'),
    type: 'date'
  },
  {
    field: 'amount',
    headerName: t('finance.amount'),
    type: 'currency',
    cellRenderer: (params: any) => {
      const formattedAmount = formattedPendingAmounts.value[params.data.id] || '...';
      return `<span class="currency-amount">${formattedAmount}</span>`;
    }
  },
  {
    field: 'description',
    headerName: t('finance.description'),
    type: 'text'
  }
]);

// Actions definitions for pending payments grid - make reactive to language changes
const pendingActions = computed(() => {
  const actions = [];
  
  // Edit action (no specific permission check needed for payment editing)
  actions.push({
    name: 'edit',
    icon: 'fas fa-edit',
    label: t('common.edit'),
    tooltip: t('common.edit'),
    class: 'edit-btn'
  });
  
  // Validate action - check validate payment permission
  if (hasPermissionForProject(PermissionType.VALIDATE_PAYMENT, props.projectId).value) {
    actions.push({
      name: 'validate',
      icon: 'fas fa-check-circle',
      label: t('finance.validate'),
      tooltip: t('finance.validate'),
      class: 'validate-btn'
    });
  }
  
  // Cancel action (no specific permission check needed for payment cancellation)
  actions.push({
    name: 'cancel',
    icon: 'fas fa-times-circle',
    label: t('common.cancel'),
    tooltip: t('finance.cancelPayment'),
    class: 'cancel-btn'
  });
  
  // View and download actions (always available)
  actions.push({
    name: 'view',
    icon: 'fas fa-eye',
    label: t('documents.view'),
    tooltip: t('documents.view'),
    class: 'view-btn',
    condition: (data: any) => !!data.documentId
  });
  
  actions.push({
    name: 'download',
    icon: 'fas fa-download',
    label: t('documents.download'),
    tooltip: t('documents.download'),
    class: 'download-btn',
    condition: (data: any) => !!data.documentId
  });
  
  return actions;
});

const transactionColumns = computed(() => [
  {
    field: 'transactionDate',
    headerName: t('finance.transactionDate'),
    type: 'date',
    width: 110
  },
  {
    field: 'type',
    headerName: t('finance.type'),
    cellRenderer: (params: any) => {
      const type = params.value;
      const badgeClass = type === 'PAYMENT' ? 'badge-success' : 'badge-danger';
      const icon = type === 'PAYMENT' ? 'fa-arrow-down' : 'fa-arrow-up';
      return `
        <span class="type-badge ${badgeClass}">
          <i class="fas ${icon}"></i>
          ${t(`finance.${type.toLowerCase()}`)}
        </span>
      `;
    },
    type: 'text',
    width: 130
  },
  {
    field: 'amount',
    headerName: t('finance.amount'),
    type: 'currency',
    cellClass: (params: any) => params.data.type === 'EXPENSE' ? 'negative-amount' : 'positive-amount',
    width: 110,
    cellRenderer: (params: any) => {
      const formattedAmount = formattedTransactionAmounts.value[params.data.id] || '...';
      const cssClass = params.data.type === 'EXPENSE' ? 'negative-amount' : 'positive-amount';
      return `<span class="currency-amount ${cssClass}">${formattedAmount}</span>`;
    }
  },
  {
    field: 'taskFullName',
    headerName: t('finance.task'),
    type: 'text'
  },
  {
    field: 'status',
    headerName: t('finance.status'),
    cellRenderer: (params: any) => `
      <span class="status-badge status-${params.value.toLowerCase()}">
        ${t(`finance.statusOptions.${params.value.toLowerCase()}`)}
      </span>
    `,
    type: 'text',
    width: 100
  }
]);

// Actions for transactions grid - make reactive to language changes
const transactionActions = computed(() => {
  const actions = [];
  
  // Edit and cancel actions for expenses - check manage expense permission
  if (hasPermissionForProject(PermissionType.MANAGE_EXPENSE, props.projectId).value) {
    actions.push({
      name: 'edit',
      icon: 'fas fa-edit',
      label: t('common.edit'),
      tooltip: t('common.edit'),
      class: 'edit-btn',
      condition: (data: any) => data.type === 'EXPENSE'
    });
    
    actions.push({
      name: 'cancel',
      icon: 'fas fa-times-circle',
      label: t('common.cancel'),
      tooltip: t('finance.cancelTransaction'),
      class: 'cancel-btn',
      condition: (data: any) => data.type === 'EXPENSE'
    });
  }
  
  // View and download actions (always available)
  actions.push({
    name: 'view',
    icon: 'fas fa-eye',
    label: t('documents.view'),
    tooltip: t('documents.view'),
    class: 'view-btn',
    condition: (data: any) => !!data.documentId
  });
  
  actions.push({
    name: 'download',
    icon: 'fas fa-download',
    label: t('documents.download'),
    tooltip: t('documents.download'),
    class: 'download-btn',
    condition: (data: any) => !!data.documentId
  });
  
  return actions;
});

// Provisioning requests columns
const provisioningRequestColumns = computed(() => [
  {
    field: 'createdAt',
    headerName: t('provisioning.requestDate'),
    type: 'date',
    width: 110
  },
  {
    field: 'createdByName',
    headerName: t('provisioning.requestedBy'),
    type: 'text',
    width: 150
  },
  {
    field: 'requestedAmount',
    headerName: t('provisioning.amount'),
    type: 'currency',
    cellClass: 'positive-amount',
    width: 120,
    cellRenderer: (params: any) => {
      const formattedAmount = formattedProvisioningAmounts.value[params.data.id] || '...';
      return `<span class="currency-amount positive-amount">${formattedAmount}</span>`;
    }
  },
  {
    field: 'provisionDeadline',
    headerName: t('provisioning.deadline'),
    type: 'date',
    width: 110,
    cellRenderer: (params: any) => {
      const deadline = new Date(params.value);
      const today = new Date();
      const isOverdue = deadline < today;
      const cssClass = isOverdue ? 'text-danger' : '';
      return `<span class="${cssClass}">${params.value}</span>`;
    }
  },
  {
    field: 'description',
    headerName: t('provisioning.description'),
    type: 'text',
    flex: 1
  },
  {
    field: 'status',
    headerName: t('provisioning.status'),
    cellRenderer: (params: any) => {
      const statusMap: Record<string, { class: string; icon: string }> = {
        'PENDING': { class: 'status-pending', icon: 'fa-clock' },
        'APPROVED': { class: 'status-approved', icon: 'fa-check-circle' },
        'REJECTED': { class: 'status-rejected', icon: 'fa-times-circle' }
      };
      const status = statusMap[params.value] || statusMap['PENDING'];
      return `
        <span class="status-badge ${status.class}">
          <i class="fas ${status.icon}"></i>
          ${t(`provisioning.statusOptions.${params.value.toLowerCase()}`)}
        </span>
      `;
    },
    type: 'text',
    width: 120
  },
  {
    field: 'respondedByName',
    headerName: t('provisioning.respondedBy'),
    type: 'text',
    width: 150,
    cellRenderer: (params: any) => params.value || '-'
  }
]);

// Actions for provisioning requests grid
const provisioningActions = computed(() => {
  const actions = [];
  
  // Approve and Reject actions - only for PENDING requests and client users
  if (hasPermissionForProject(PermissionType.ANSWER_FINANCE_PROVISIONING, props.projectId).value) {
    actions.push({
      name: 'approve',
      icon: 'fas fa-check',
      label: t('provisioning.approve'),
      tooltip: t('provisioning.approve'),
      class: 'approve-btn',
      condition: (data: any) => data.status === 'PENDING'
    });
    
    actions.push({
      name: 'reject',
      icon: 'fas fa-times',
      label: t('provisioning.reject'),
      tooltip: t('provisioning.reject'),
      class: 'reject-btn',
      condition: (data: any) => data.status === 'PENDING'
    });
  }
  
  return actions;
});

// Methods
const formatPendingAmounts = async () => {
  if (!pendingPayments.value?.length) return;
  
  const amounts: Record<string, string> = {};
  for (const payment of pendingPayments.value) {
    if (payment.id) {
      try {
        amounts[payment.id] = await formatCurrencyWithUserPreference(payment.amount);
      } catch (error) {
        console.warn('Error formatting currency for payment:', payment.id, error);
        amounts[payment.id] = payment.amount?.toString() || '0';
      }
    }
  }
  
  formattedPendingAmounts.value = amounts;
};

const formatTransactionAmounts = async () => {
  if (!transactions.value?.length) return;
  
  const amounts: Record<string, string> = {};
  for (const transaction of transactions.value) {
    if (transaction.id) {
      try {
        amounts[transaction.id] = await formatCurrencyWithUserPreference(transaction.amount);
      } catch (error) {
        console.warn('Error formatting currency for transaction:', transaction.id, error);
        amounts[transaction.id] = transaction.amount?.toString() || '0';
      }
    }
  }
  
  formattedTransactionAmounts.value = amounts;
};

const formatProvisioningRequestAmounts = async () => {
  if (!provisioningRequests.value?.length) return;
  
  const amounts: Record<string, string> = {};
  for (const request of provisioningRequests.value) {
    if (request.id) {
      try {
        amounts[request.id] = await formatCurrencyWithUserPreference(request.requestedAmount);
      } catch (error) {
        console.warn('Error formatting currency for provisioning request:', request.id, error);
        amounts[request.id] = request.requestedAmount?.toString() || '0';
      }
    }
  }
  
  formattedProvisioningAmounts.value = amounts;
};

const loadData = async () => {
  console.log('🔄 Loading finance data for project:', props.projectId);
  try {
    
    const [balanceData, transactionsData, pendingData, provisioningData] = await Promise.all([
        financeService.getBalance(props.projectId),
        financeService.getTransactions(props.projectId),
        financeService.getPendingPayments(props.projectId),
        provisioningRequestService.getRequests(props.projectId)
    ]);

    console.log('📊 Balance data:', balanceData);
    console.log('📊 Transactions data:', transactionsData);
    console.log('📊 Pending payments data:', pendingData);
    console.log('📊 Provisioning requests data:', provisioningData);

    projectBalance.value = balanceData?.currentBalance || 0;
    transactions.value = transactionsData || [];
    pendingPayments.value = pendingData?.content || [];
    provisioningRequests.value = provisioningData || [];
    pendingProvisioningCount.value = (provisioningData || []).filter((r: any) => r.status === 'PENDING').length;
    
    console.log('💰 Project balance:', projectBalance.value);
    console.log('📋 Transactions count:', transactions.value.length);
    console.log('⏳ Pending payments count:', pendingPayments.value.length);
    console.log('🤝 Provisioning requests count:', provisioningRequests.value.length);
    console.log('⏰ Pending provisioning requests:', pendingProvisioningCount.value);
    
    // Format currency amounts after loading data
    await Promise.all([
      formatPendingAmounts(),
      formatTransactionAmounts(),
      formatProvisioningRequestAmounts()
    ]);
    
    // Refresh grids to show formatted amounts
    setTimeout(() => {
      pendingPaymentsGridApi.value?.refreshCells();
      transactionsGridApi.value?.refreshCells();
      provisioningRequestsGridApi.value?.refreshCells();
    }, 100);
  } catch (error) {
    console.error('❌ Error loading finance data:', error);
    store.dispatch('notifications/showError', t('finance.errorLoading'));
  }
};

const loadTasks = async () => {
  try {
    loadingTasks.value = true;
    const response = await projectTasksService.getTasks(props.projectId);
    tasks.value = response || [];
  } catch (error) {
    console.error('Error loading tasks:', error);
    store.dispatch('notifications/showError', t('finance.errorLoadingTasks'));
  } finally {
    loadingTasks.value = false;
  }
};

const loadIntervenants = async () => {
  try {
    loadingIntervenants.value = true;
    intervenants.value = await intervenantsService.getIntervenants(props.projectId);
  } catch (error) {
    console.error('Error loading intervenants:', error);
    store.dispatch('notifications/showError', t('finance.errorLoadingIntervenants'));
  } finally {
    loadingIntervenants.value = false;
  }
};

const handlePaymentSubmit = async ({ data, isValid }: { data: any; isValid: boolean }) => {
  if (!isValid) {
    store.dispatch('notifications/showError', t('finance.fillRequiredFields'));
    return;
  }
  
  const isProvisioningApproval = !!provisioningRequestToApprove.value;
  
  try {
    // Submit the payment (backend will approve the provisioning request automatically if linked)
    await financeService.recordPayment(props.projectId, data);
    
    // Refresh data and close modal
    await loadData();
    showRecordPaymentModal.value = false;
    provisioningRequestToApprove.value = null;
    
    if (isProvisioningApproval) {
      store.dispatch('notifications/showSuccess', t('provisioning.approvedAndPaymentRecorded'));
    } else {
      store.dispatch('notifications/showSuccess', t('finance.paymentRecorded'));
    }
  } catch (error) {
    console.error('Error recording payment:', error);
    store.dispatch('notifications/showError', t('finance.errorRecordingPayment'));
  }
};const handleExpenseSubmit = async ({ data, isValid }: { data: any; isValid: boolean }) => {
  if (!isValid) {
    store.dispatch('notifications/showError', t('finance.fillRequiredFields'));
    return;
  }
  
  try {
    // Prepare expense data
    const expenseData = {
      ...data,
      taskId: data.taskId || null // Allow null taskId if not selected
    };
    
    // Submit the expense
    await financeService.recordExpense(props.projectId, expenseData);
    
    // Refresh data and close modal
    await loadData();
    showRecordExpenseModal.value = false;
    store.dispatch('notifications/showSuccess', t('finance.expenseRecorded'));
  } catch (error) {
    console.error('Error recording expense:', error);
    store.dispatch('notifications/showError', t('finance.errorRecordingExpense'));
  }
};

const validatePayment = async (transactionId: string) => {
  try {
    await financeService.validatePayment(props.projectId, transactionId);
    await loadData();
    store.dispatch('notifications/showSuccess', t('finance.paymentValidated'));
  } catch (error) {
    console.error('Error validating payment:', error);
    store.dispatch('notifications/showError', t('finance.errorValidatingPayment'));
  }
};

const editPayment = (payment: any) => {
  editingPayment.value = payment;
  showEditPaymentModal.value = true;
};

const handleEditPaymentSubmit = async ({ data, isValid }: { data: any; isValid: boolean }) => {
  if (!isValid) {
    store.dispatch('notifications/showError', t('finance.fillRequiredFields'));
    return;
  }
  
  try {
    // Submit the edited payment
    await financeService.editPendingPayment(props.projectId, editingPayment.value.id, data);
    
    // Refresh data and close modal
    await loadData();
    showEditPaymentModal.value = false;
    editingPayment.value = null;
    store.dispatch('notifications/showSuccess', t('finance.paymentUpdated'));
  } catch (error) {
    console.error('Error updating payment:', error);
    store.dispatch('notifications/showError', t('finance.errorUpdatingPayment'));
  }
};

const cancelPayment = (transactionId: string) => {
  // Store the transaction ID and show confirmation modal
  paymentToCancel.value = transactionId;
  showCancelPaymentModal.value = true;
};

const confirmCancelPayment = async () => {
  if (!paymentToCancel.value) return;
  
  try {
    await financeService.cancelPendingPayment(props.projectId, paymentToCancel.value);
    await loadData();
    store.dispatch('notifications/showSuccess', t('finance.paymentCancelled'));
  } catch (error) {
    console.error('Error cancelling payment:', error);
    store.dispatch('notifications/showError', t('finance.errorCancellingPayment'));
  } finally {
    // Reset state
    showCancelPaymentModal.value = false;
    paymentToCancel.value = null;
  }
};

const cancelCancelPayment = () => {
  showCancelPaymentModal.value = false;
  paymentToCancel.value = null;
};

const openPaymentModal = () => {
  console.log('Opening payment modal');
  showRecordPaymentModal.value = true;
};

const openExpenseModal = async () => {
  console.log('Opening expense modal');
  await Promise.all([loadTasks(), loadIntervenants()]);
  showRecordExpenseModal.value = true;
};

const openProvisioningModal = () => {
  console.log('Opening provisioning modal');
  showProvisioningModal.value = true;
};

const handleProvisioningSubmit = async ({ data, isValid }: { data: ProvisioningRequestData; isValid: boolean }) => {
  if (!isValid) {
    notifyError(t('finance.fillRequiredFields'));
    return;
  }
  
  try {
    await provisioningRequestService.createRequest(props.projectId as number, data);
    
    // Close modal
    showProvisioningModal.value = false;
    
    // Show success notification
    notifySuccess(t('provisioning.requestSubmitted'));
    
    // Optionally refresh data to show updated pending requests count
    await loadData();
  } catch (error) {
    console.error('Error submitting provisioning request:', error);
    notifyError(t('provisioning.errorSubmitting'));
  }
};

// Edit expense
const editExpense = async (expense: any) => {
  await Promise.all([loadTasks(), loadIntervenants()]);
  editingExpense.value = expense;
  showEditExpenseModal.value = true;
};

const handleEditExpenseSubmit = async ({ data, isValid }: { data: any; isValid: boolean }) => {
  if (!isValid) {
    store.dispatch('notifications/showError', t('finance.fillRequiredFields'));
    return;
  }
  
  try {
    // Submit the edited expense
    await financeService.editExpense(props.projectId, editingExpense.value.id, data);
    
    // Refresh data and close modal
    await loadData();
    showEditExpenseModal.value = false;
    editingExpense.value = null;
    store.dispatch('notifications/showSuccess', t('finance.expenseUpdated'));
  } catch (error) {
    console.error('Error updating expense:', error);
    store.dispatch('notifications/showError', t('finance.errorUpdatingExpense'));
  }
};

// Cancel transaction
const cancelTransaction = (transactionId: string) => {
  // Store the transaction ID and show confirmation modal
  transactionToCancel.value = transactionId;
  showCancelTransactionModal.value = true;
};

const confirmCancelTransaction = async () => {
  if (!transactionToCancel.value) return;
  
  try {
    await financeService.cancelTransaction(props.projectId, transactionToCancel.value);
    await loadData();
    store.dispatch('notifications/showSuccess', t('finance.transactionCancelled'));
  } catch (error) {
    console.error('Error cancelling transaction:', error);
    store.dispatch('notifications/showError', t('finance.errorCancellingTransaction'));
  } finally {
    // Reset state
    showCancelTransactionModal.value = false;
    transactionToCancel.value = null;
  }
};

const cancelCancelTransaction = () => {
  showCancelTransactionModal.value = false;
  transactionToCancel.value = null;
};

// Invoice viewing and downloading
const viewInvoice = (transaction: any) => {
  if (!transaction?.documentId) {
    store.dispatch('notifications/showError', t('errors.noInvoiceAttached'));
    return;
  }
  
  // Convert transaction to document format for the document viewer
  const document = transactionToDocumentFormat(transaction);
  selectedDocument.value = document;
  showDocumentViewerModal.value = true;
};

const downloadInvoice = async (transaction: any) => {
  if (!props.projectId || !transaction?.documentId) {
    store.dispatch('notifications/showError', t('errors.invalidInvoiceDownload'));
    return;
  }

  try {
    await DocumentService.downloadDocument(
      props.projectId, 
      transaction.documentId,
      transaction.invoiceFileName || `invoice-${transaction.id}.pdf`
    );
  } catch (err) {
    console.error('Error downloading invoice:', err);
    store.dispatch('notifications.showError', t('errors.downloadingInvoiceError'));
  }
};

// Helper function to convert a transaction to document format
const transactionToDocumentFormat = (transaction: any) => {
  return {
    id: transaction.documentId,
    fileName: transaction.invoiceFileName || `invoice-${transaction.id}.pdf`,
    fileType: guessFileTypeFromName(transaction.invoiceFileName || 'invoice.pdf'),
    docType: 'recu', // Default document type for invoices
    description: transaction.description || t('finance.invoice'),
    createdAt: transaction.createdAt
  };
};

// Helper to guess file type from filename
const guessFileTypeFromName = (fileName: string) => {
  const extension = fileName.split('.').pop()?.toLowerCase();
  const mimeTypes: Record<string, string> = {
    'pdf': 'application/pdf',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif'
  };
  
  return mimeTypes[extension || ''] || 'application/octet-stream';
};

// Update formatted balance when projectBalance changes
watch(projectBalance, async (newBalance: number) => {
  formattedBalance.value = await formatCurrencyWithUserPreference(newBalance);
}, { immediate: true });

// Grid ready event handlers
const onPendingGridReady = (params: any) => {
  pendingPaymentsGridApi.value = params.api;
  setTimeout(() => {
    pendingPaymentsGridApi.value.sizeColumnsToFit();
  }, 0);
};

const onTransactionGridReady = (params: any) => {
  transactionsGridApi.value = params.api;
  setTimeout(() => {
    transactionsGridApi.value.sizeColumnsToFit();
  }, 0);
};

const provisioningRequestsGridApi = ref(null);

const onProvisioningGridReady = (params: any) => {
  provisioningRequestsGridApi.value = params.api;
  setTimeout(() => {
    provisioningRequestsGridApi.value.sizeColumnsToFit();
  }, 0);
};

// Define a resize handler function
const handleResize = () => {
  setTimeout(() => {
    pendingPaymentsGridApi.value?.sizeColumnsToFit();
    transactionsGridApi.value?.sizeColumnsToFit();
    provisioningRequestsGridApi.value?.sizeColumnsToFit();
  }, 100);
};

// Action handlers for AppDataGrid components
const handlePendingAction = (action: any, data: any) => {
  if (!data) return;
  
  switch (action.name) {
    case 'edit':
      editPayment(data);
      break;
    case 'validate':
      validatePayment(data.id);
      break;    case 'cancel':
      cancelPayment(data.id);
      break;
    case 'view':
      viewInvoice(data);
      break;
    case 'download':
      downloadInvoice(data);
      break;
    default:
      console.warn('Unknown action:', action.name);
  }
};

const handleTransactionAction = (action: any, data: any) => {
  if (!data) return;
  
  switch (action.name) {
    case 'edit':
      editExpense(data);
      break;
    case 'cancel':
      cancelTransaction(data.id);
      break;
    case 'view':
      viewInvoice(data);
      break;
    case 'download':
      downloadInvoice(data);
      break;
    default:
      console.warn('Unknown action:', action.name);
  }
};

const handleProvisioningAction = (action: any, data: any) => {
  if (!data) return;
  
  switch (action.name) {
    case 'approve':
      approveProvisioningRequest(data);
      break;
    case 'reject':
      rejectProvisioningRequest(data);
      break;
    default:
      console.warn('Unknown provisioning action:', action.name);
  }
};

// Provisioning request methods
const approveProvisioningRequest = async (request: any) => {
  // Set the provisioning request to approve and open payment modal
  provisioningRequestToApprove.value = request;
  showRecordPaymentModal.value = true;
};

const rejectProvisioningRequest = (request: any) => {
  // Reset notes and store the request
  rejectionNotes.value = '';
  provisioningRequestToReject.value = request;
  showRejectProvisioningModal.value = true;
};

const confirmRejectProvisioning = async () => {
  if (!provisioningRequestToReject.value) return;
  
  try {
    await provisioningRequestService.rejectRequest(
      props.projectId,
      provisioningRequestToReject.value.id,
      { responseNotes: rejectionNotes.value || '' }
    );
    
    notifySuccess(t('provisioning.rejected'));
    await loadData(); // Reload all data
  } catch (error) {
    console.error('Error rejecting provisioning request:', error);
    notifyError(t('provisioning.rejectFailed'));
  } finally {
    // Reset state
    showRejectProvisioningModal.value = false;
    provisioningRequestToReject.value = null;
    rejectionNotes.value = '';
  }
};

const cancelRejectProvisioning = () => {
  showRejectProvisioningModal.value = false;
  provisioningRequestToReject.value = null;
  rejectionNotes.value = '';
};

// Computed properties for stats
const totalPayments = computed(() => {
  return transactions.value
    .filter((t: any) => t.type === 'PAYMENT')
    .reduce((sum: number, t: any) => sum + (t.amount || 0), 0);
});

const totalExpenses = computed(() => {
  return transactions.value
    .filter((t: any) => t.type === 'EXPENSE')
    .reduce((sum: number, t: any) => sum + (t.amount || 0), 0);
});

const paymentsCount = computed(() => {
  return transactions.value.filter((t: any) => t.type === 'PAYMENT').length;
});

const expensesCount = computed(() => {
  return transactions.value.filter((t: any) => t.type === 'EXPENSE').length;
});

// Formatted currency values
const formattedTotalPayments = ref('€0.00');
const formattedTotalExpenses = ref('€0.00');

// Watch for changes in totals and format them
watch(totalPayments, async (newValue: number) => {
  formattedTotalPayments.value = await formatCurrencyWithUserPreference(newValue);
}, { immediate: true });

watch(totalExpenses, async (newValue: number) => {
  formattedTotalExpenses.value = await formatCurrencyWithUserPreference(newValue);
}, { immediate: true });

const formatCurrency = async (value: number) => {
  return await formatCurrencyWithUserPreference(value);
};

// Component lifecycle
onMounted(async () => {
  console.log('🏗️ ProjectFinance component mounted with projectId:', props.projectId);
  
  // Initialize formatted balance
  formattedBalance.value = await formatCurrencyWithUserPreference(projectBalance.value);
  
  loadData();
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('finance.currentBalance')), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["balance-amount", { 'negative': projectBalance.value < 0 }])
            }, _toDisplayString(formattedBalance.value), 3),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: openPaymentModal
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-plus" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('finance.recordPayment')), 1)
              ]),
              _createVNode(PermissionGuard, { permission: 'MANAGE_EXPENSE' }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "btn btn-secondary",
                    onClick: openExpenseModal
                  }, [
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-minus" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('finance.recordExpense')), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(PermissionGuard, { permission: 'REQUEST_FINANCE_PROVISIONING' }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "btn btn-info",
                    onClick: openProvisioningModal
                  }, [
                    _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-hand-holding-usd" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('provisioning.submit')), 1)
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('finance.totalPayments')), 1),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "stat-icon green" }, [
              _createElementVNode("i", { class: "fas fa-arrow-down" })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(formattedTotalPayments.value), 1),
          _createElementVNode("div", _hoisted_13, [
            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-check-circle" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(paymentsCount.value) + " " + _toDisplayString(_ctx.$t('finance.transactions')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('finance.totalExpenses')), 1),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "stat-icon red" }, [
              _createElementVNode("i", { class: "fas fa-arrow-up" })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_17, _toDisplayString(formattedTotalExpenses.value), 1),
          _createElementVNode("div", _hoisted_18, [
            _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(expensesCount.value) + " " + _toDisplayString(_ctx.$t('finance.transactions')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('finance.transactionHistory')), 1),
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "stat-icon blue" }, [
              _createElementVNode("i", { class: "fas fa-exchange-alt" })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_22, _toDisplayString(transactions.value.length), 1),
          _createElementVNode("div", _hoisted_23, [
            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-list" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('finance.allTransactions')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('finance.pendingPayments')), 1),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "stat-icon purple" }, [
              _createElementVNode("i", { class: "fas fa-clock" })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_27, _toDisplayString(pendingPayments.value.length), 1),
          _createElementVNode("div", _hoisted_28, [
            _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fas fa-hourglass-half" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('finance.toValidate')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createTextVNode(_toDisplayString(activeTab.value === 'history' ? _ctx.$t('finance.transactionHistory') : 
            activeTab.value === 'pending' ? _ctx.$t('finance.pendingPayments') :
            _ctx.$t('provisioning.requests')) + " ", 1),
          _createElementVNode("span", _hoisted_32, _toDisplayString(activeTab.value === 'history' ? transactions.value.length : 
            activeTab.value === 'pending' ? pendingPayments.value.length :
            provisioningRequests.value.length), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("button", {
            class: _normalizeClass(["tab-button", { active: activeTab.value === 'history' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'history'))
          }, _toDisplayString(_ctx.$t('finance.transactionHistory')), 3),
          _createElementVNode("button", {
            class: _normalizeClass(["tab-button", { active: activeTab.value === 'pending' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'pending'))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('finance.pendingPayments')) + " ", 1),
            (pendingPayments.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(pendingPayments.value.length), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass(["tab-button", { active: activeTab.value === 'provisioning' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'provisioning'))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('provisioning.requests')) + " ", 1),
            (pendingProvisioningCount.value > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(pendingProvisioningCount.value), 1))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_36, [
        _createVNode(AppDataGrid, {
          ref: "transactionsGrid",
          class: "transactions-grid",
          columnDefs: transactionColumns.value,
          rowData: transactions.value,
          defaultColDef: defaultColDef,
          actions: transactionActions.value,
          pagination: true,
          pageSize: 20,
          pageSizeOptions: [20, 30, 50, 100],
          suppressPaginationPanel: false,
          animateRows: true,
          showSearch: true,
          searchPlaceholder: _ctx.$t('finance.searchTransactions'),
          onGridReady: onTransactionGridReady,
          onActionClicked: handleTransactionAction,
          gridStyle: "width: 100%;",
          domLayout: "autoHeight"
        }, null, 8, ["columnDefs", "rowData", "actions", "searchPlaceholder"])
      ], 512), [
        [_vShow, activeTab.value === 'history']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_37, [
        _createVNode(AppDataGrid, {
          ref: "pendingPaymentsGrid",
          class: "pending-payments-grid",
          columnDefs: pendingPaymentsColumns.value,
          rowData: pendingPayments.value,
          defaultColDef: defaultColDef,
          actions: pendingActions.value,
          pagination: true,
          pageSize: 10,
          pageSizeOptions: [10, 25, 50],
          suppressPaginationPanel: false,
          animateRows: true,
          showSearch: true,
          searchPlaceholder: _ctx.$t('finance.searchPayments'),
          onGridReady: onPendingGridReady,
          onActionClicked: handlePendingAction,
          gridStyle: "width: 100%;",
          domLayout: "autoHeight"
        }, null, 8, ["columnDefs", "rowData", "actions", "searchPlaceholder"])
      ], 512), [
        [_vShow, activeTab.value === 'pending']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_38, [
        (provisioningRequests.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "empty-icon" }, [
                _createElementVNode("i", { class: "fas fa-hand-holding-usd" })
              ], -1)),
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('provisioning.noRequests')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('provisioning.noRequestsDescription')), 1)
            ]))
          : (_openBlock(), _createBlock(AppDataGrid, {
              key: 1,
              ref: "provisioningRequestsGrid",
              class: "provisioning-requests-grid",
              columnDefs: provisioningRequestColumns.value,
              rowData: provisioningRequests.value,
              defaultColDef: defaultColDef,
              actions: provisioningActions.value,
              pagination: true,
              pageSize: 10,
              pageSizeOptions: [10, 25, 50],
              suppressPaginationPanel: false,
              animateRows: true,
              showSearch: true,
              searchPlaceholder: _ctx.$t('provisioning.searchRequests'),
              onGridReady: onProvisioningGridReady,
              onActionClicked: handleProvisioningAction,
              gridStyle: "width: 100%;",
              domLayout: "autoHeight"
            }, null, 8, ["columnDefs", "rowData", "actions", "searchPlaceholder"]))
      ], 512), [
        [_vShow, activeTab.value === 'provisioning']
      ])
    ]),
    _createVNode(RecordPaymentModal, {
      isVisible: showRecordPaymentModal.value,
      provisioningRequest: provisioningRequestToApprove.value,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => {showRecordPaymentModal.value = false; provisioningRequestToApprove.value = null}),
      onSubmit: handlePaymentSubmit
    }, null, 8, ["isVisible", "provisioningRequest"]),
    _createVNode(RecordExpenseModal, {
      isVisible: showRecordExpenseModal.value,
      tasks: tasks.value,
      intervenants: intervenants.value,
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (showRecordExpenseModal.value = false)),
      onSubmit: handleExpenseSubmit
    }, null, 8, ["isVisible", "tasks", "intervenants"]),
    _createVNode(RecordPaymentModal, {
      isVisible: showEditPaymentModal.value,
      isEditMode: true,
      payment: editingPayment.value,
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (showEditPaymentModal.value = false)),
      onSubmit: handleEditPaymentSubmit
    }, null, 8, ["isVisible", "payment"]),
    _createVNode(ConfirmModal, {
      isVisible: showCancelPaymentModal.value,
      title: _ctx.$t('finance.cancelPayment'),
      message: _ctx.$t('finance.confirmCancelPaymentMessage'),
      details: _ctx.$t('finance.confirmCancelPaymentDetails'),
      confirmText: _ctx.$t('finance.cancelPayment'),
      cancelText: _ctx.$t('common.cancel'),
      type: "danger",
      onCancel: cancelCancelPayment,
      onConfirm: confirmCancelPayment
    }, null, 8, ["isVisible", "title", "message", "details", "confirmText", "cancelText"]),
    _createVNode(RecordExpenseModal, {
      isVisible: showEditExpenseModal.value,
      isEditMode: true,
      expense: editingExpense.value,
      tasks: tasks.value,
      intervenants: intervenants.value,
      onCancel: _cache[6] || (_cache[6] = ($event: any) => (showEditExpenseModal.value = false)),
      onSubmit: handleEditExpenseSubmit
    }, null, 8, ["isVisible", "expense", "tasks", "intervenants"]),
    _createVNode(ConfirmModal, {
      isVisible: showCancelTransactionModal.value,
      title: _ctx.$t('finance.cancelTransaction'),
      message: _ctx.$t('finance.confirmCancelTransactionMessage'),
      details: _ctx.$t('finance.confirmCancelTransactionDetails'),
      confirmText: _ctx.$t('finance.cancelTransaction'),
      cancelText: _ctx.$t('common.cancel'),
      type: "danger",
      onCancel: cancelCancelTransaction,
      onConfirm: confirmCancelTransaction
    }, null, 8, ["isVisible", "title", "message", "details", "confirmText", "cancelText"]),
    _createVNode(ProvisioningRequestModal, {
      isVisible: showProvisioningModal.value,
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (showProvisioningModal.value = false)),
      onSubmit: handleProvisioningSubmit
    }, null, 8, ["isVisible"]),
    _createVNode(AppModal, {
      show: showRejectProvisioningModal.value,
      title: _ctx.$t('provisioning.rejectRequest'),
      size: "medium",
      onClose: cancelRejectProvisioning
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(AppButton, {
            type: "button",
            variant: "outline",
            onClick: cancelRejectProvisioning
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(AppButton, {
            type: "button",
            variant: "danger",
            onClick: confirmRejectProvisioning
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('provisioning.reject')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "reject-provisioning-modal__icon" }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                width: "32",
                height: "32"
              }, [
                _createElementVNode("path", {
                  fill: "currentColor",
                  d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t('provisioning.confirmRejectMessage')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _cache[23] || (_cache[23] = _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              width: "20",
              height: "20"
            }, [
              _createElementVNode("path", {
                fill: "currentColor",
                d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('provisioning.confirmRejectDetails')), 1)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('provisioning.rejectionNotes')), 1),
            _withDirectives(_createElementVNode("textarea", {
              id: "rejectionNotes",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((rejectionNotes).value = $event)),
              class: "reject-provisioning-modal__textarea",
              placeholder: _ctx.$t('provisioning.rejectionNotesPlaceholder'),
              rows: "4"
            }, null, 8, _hoisted_48), [
              [_vModelText, rejectionNotes.value]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "title"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (showDocumentViewerModal.value && selectedDocument.value)
            ? (_openBlock(), _createBlock(DocumentViewerModal, {
                key: 0,
                projectId: _ctx.projectId,
                document: selectedDocument.value,
                onClose: _cache[9] || (_cache[9] = ($event: any) => (showDocumentViewerModal.value = false))
              }, null, 8, ["projectId", "document"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})